import { render, staticRenderFns } from "./FancyButton.vue?vue&type=template&id=7a4bfe71&"
import script from "./FancyButton.vue?vue&type=script&lang=js&"
export * from "./FancyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports